import GeneratedOfferServiceApi from "./generated/GeneratedOfferServiceApi"

class OfferServiceApi extends GeneratedOfferServiceApi {

}

export const offerServiceApi = new OfferServiceApi()
